module.exports = __webpack_public_path__ + "img/lebanon-admin.4a588382.png";